module.exports={thousands_abbreviation:"${num}K",millions_abbreviation:"${num}M"};